import {
  ALL_SESSIONS_ID,
  ALL_SESSIONS_OPTION,
} from '~features/new-dashboard/constants';

import type { SessionOption } from '~features/shared/session-selector';

export function useDashboardSessionScope(
  selectedSession: SessionOption | undefined | null,
  isSessionsReady: boolean,
) {
  const isAllSessions =
    selectedSession?.value === ALL_SESSIONS_ID ||
    selectedSession == null;

  const apiSessionId = isAllSessions
    ? ALL_SESSIONS_ID
    : (selectedSession?.value ?? '');

  const isReady =
    isSessionsReady &&
    (isAllSessions || apiSessionId.length > 0);

  return {
    selectedSession: isAllSessions ? ALL_SESSIONS_OPTION : selectedSession,
    isAllSessions,
    apiSessionId,
    isReady,
  };
}
